import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'if_yes_please_describe_1'

export const dataPointDefinition = {
  retracedId: 'if_yes_please_describe_1',
  name: 'If yes, please describe:',
  description: '',
  meta: {
    slcpMeta: {
      key: 'fp-pi-22',
      number: 'FP-PRO-18.1',
      dataType: 'string',
      masterType: 'Follow-up',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'no-verf-required',
      verificationSelectionOptList: 'no-verf-data',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[1],fp-pi-21,Yes',
      machineShowHide: '[1],fp-pi-21,1',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-pi-22', version: '1.7.0', provider: 'slcp'}],
  sortingId: 28120,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
